module.exports = __webpack_public_path__ + "img/drachenmakiseitlichmitlogo.6359c886.png";